module.exports = __webpack_public_path__ + "img/img-2.3c7a2520.png";